import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VenueOperatorCreateEditForm from './Components/VenueOperatorCreateEditForm';
import VenueOperatorApi from './VenueOperatorApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: VenueOperatorCreateEditForm,
                getCreate: VenueOperatorApi.create,
                getClone: VenueOperatorApi.getOne,
                defaults: {},
                successMessage: "VenueOperator Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}